module.exports = require('./lib/dynamic');
